/**
 * Utilities
 */
 Array.prototype.unique = function() {
    let a = this.concat();

    for (let i = 0; i < a.length; i++) {
        for (let j = i + 1; j < a.length; j++) {
            if (a[i] === a[j])
                a.splice(j--, 1);
        }
    }

    return a;
};


/**
 * Query params logic
 */

function getUrlParameter(param) {
    let queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);

    if (urlParams.get(param)) return urlParams.get(param);

    return false;
}

// Se trovo il PID nell'url, riporto l'utente nella stessa posizione in cui si trovava prima di andare nella PDP

function checkPid() {
    let pid = getUrlParameter('pid');

    if (pid) {
        let productCard = document.querySelectorAll('[data-product-id="' + pid + '"]')[0];

        if (productCard) {
            setTimeout(() => {
                let coordinate = productCard.getBoundingClientRect();

                window.scrollTo(coordinate.x, Math.abs(coordinate.y) - 130);
                if (document.getElementById('PageContainer'))
                    document.getElementById('PageContainer').scrollTop = Math.abs(coordinate.y - 170);

                // tolgo il pid una volta trovato il prodotto

                /*
                    let queryString = window.location.search;
                    let urlParams = new URLSearchParams(queryString);
                    urlParams.delete('pid');
                    let baseUrl = window.location.href.split('?')[0];
                    let newUrl = baseUrl + '?' + urlParams.toString();
                    
                    history.replaceState(null, null, newUrl);
                */
            }, 500);
        }
    }
}

/**
 * Sort delle taglie a frontend, secondo le schiere indicate nel customize
 */
var sortSize = function(item, wrapper, productSelector) {

    var sizesRangeClothing = window.Nunalie.sizesRangeClothing ? window.Nunalie.sizesRangeClothing : '';
    var sizesRangeShoe = window.Nunalie.sizesRangeShoe ? window.Nunalie.sizesRangeShoe : '';
    var sizesRangeAccessory = window.Nunalie.sizesRangeAccessory ? window.Nunalie.sizesRangeAccessory : '';

    var rangeClothing = sizesRangeClothing.split('|');
    var rangeShoe = sizesRangeShoe.split('|');
    var rangeAccessory = sizesRangeAccessory.split('|');

    var clothingSizesFormatted = [];
    var shoeSizesFormatted = [];
    var accessorySizesFormatted = [];

    $.each(rangeClothing, function(index, value) {
        var limits = value.split(',');

        clothingSizesFormatted.push(limits);
    });

    $.each(rangeShoe, function(index, value) {
        var rangesSizeSplitted = value;
        if (value.includes('=')) {
            const rangeSplitted = value.split('=');
            rangesSizeSplitted = rangeSplitted[1];
        }
        var limits = rangesSizeSplitted.split(',');

        shoeSizesFormatted.push(limits);
    });

    $.each(rangeAccessory, function(index, value) {
        var limits = value.split(',');

        accessorySizesFormatted.push(limits);
    });

    $(productSelector).each(function() {

        var product = $(this);
        var isNumeric = true;
        var department = product.data('category') ? product.data('category').toLowerCase() : null;

        // Controllo tutte le taglie per verificare che non siano valori numerici ma con scale taglie ad-hoc come 00 o 0
        product.find(item).each(function() {
            if (!$.isNumeric($(this).data('size')) && $(this).data('size') != '0' && $(this).data('size') != '00') {
                isNumeric = false;
            }
        });

        // Se tutte le taglie sono di tipo numerico, posso ordinarle numericamente
        if (isNumeric) {
            product.find(item).sort(function(a, b) {
                var sizeA = parseFloat($(a).attr('data-size'));
                var sizeB = parseFloat($(b).attr('data-size'));

                return sizeA - sizeB;
            }).appendTo(product.find(wrapper));
        } else {
            // Altrimenti analizzo il department del prodotto, prendo la prima taglia e la ricerco nelle scale taglie inserite nel customize
            var firstVariant = product.find(item).first().data('size') + '';
            var sortArray = false;

            if (department == 'abbigliamento' || department == 'clothing' || department == 'ropa') {
                clothingSizesFormatted.forEach(function(clothingSizeFormatted) {
                    if (clothingSizeFormatted.indexOf(firstVariant) > -1) {
                        sortArray = clothingSizeFormatted;
                    }
                });
            } else if (department == 'scarpe' || department == 'footwear' || department == 'zapatos') {
                shoeSizesFormatted.forEach(function(shoeSizeFormatted) {
                    if (shoeSizeFormatted.indexOf(firstVariant) > -1) {
                        sortArray = shoeSizeFormatted;
                    }
                });
            } else if (department == 'accessori' || department == 'accessories' || department == 'accesorios') {
                accessorySizesFormatted.forEach(function(accessorySizeFormatted) {
                    if (accessorySizeFormatted.indexOf(firstVariant) > -1) {
                        sortArray = accessorySizeFormatted;
                    }
                });
            }

            if (sortArray) {
                // Ordino le varianti a seconda della scala taglia selezionata
                product.find(item).sort(function(a, b) {
                    var sizeA = $(a).data('size') + '';
                    var sizeB = $(b).data('size') + '';

                    return sortArray.indexOf(sizeA) - sortArray.indexOf(sizeB);
                }).appendTo(product.find(wrapper));
            }
        }
    });
};

var sortSizeVanillaJs = function(item, wrapper, productSelector) {

    let sizesRangeClothing = window.Nunalie.sizesRangeClothing ? window.Nunalie.sizesRangeClothing : '';
    let sizesRangeShoe = window.Nunalie.sizesRangeShoe ? window.Nunalie.sizesRangeShoe : '';
    let sizesRangeAccessory = window.Nunalie.sizesRangeAccessory ? window.Nunalie.sizesRangeAccessory : '';

    let rangeClothing = sizesRangeClothing.split('|');
    let rangeShoe = sizesRangeShoe.split('|');
    let rangeAccessory = sizesRangeAccessory.split('|');

    let clothingSizesFormatted = [];
    let shoeSizesFormatted = [];
    let accessorySizesFormatted = [];
    
    Array.from(rangeClothing, (element, index) => { 
        let limits = element.split(',');
        clothingSizesFormatted.push(limits);
    });

    Array.from(rangeShoe, (element, index) => { 
        let rangesSizeSplitted = element;
        if (element.includes('=')) {
            const rangeSplitted = element.split('=');
            rangesSizeSplitted = rangeSplitted[1];
        }
        
        let limits = rangesSizeSplitted.split(',');

        shoeSizesFormatted.push(limits);
    });

    Array.from(rangeAccessory, (element, index) => { 
        let limits = element.split(',');
        accessorySizesFormatted.push(limits);
    });

    document.querySelectorAll(productSelector).forEach(element => {
        const product = element;
        let isNumeric = true;
        let department = product.getAttribute('data-category') ? product.getAttribute('data-category').toLowerCase() : null;

        // Controllo tutte le taglie per verificare che non siano valori numerici ma con scale taglie ad-hoc come 00 o 0
        product.querySelectorAll(item).forEach(element => {
            if (!window.isNumeric(element.getAttribute('data-size')) && element.getAttribute('data-size') != '0' && element.getAttribute('data-size') != '00') {
                isNumeric = false;
            }
        });

        // Se tutte le taglie sono di tipo numerico, posso ordinarle numericamente
        if (isNumeric) {
            let sizesArray = Array.from(product.querySelectorAll(item)).sort(function(a, b) {
                    let sizeA = parseFloat(a.getAttribute('data-size'));
                    let sizeB = parseFloat(b.getAttribute('data-size'));

                    return sizeA - sizeB;
                }); // .appendTo(product.querySelector(wrapper));
            product.querySelector(wrapper).append(sizesArray);
        } else {
            // Altrimenti analizzo il department del prodotto, prendo la prima taglia e la ricerco nelle scale taglie inserite nel customize
            let firstVariant = product.querySelector(item).getAttribute('data-size') + '';
            let sortArray = false;

            if (department == 'abbigliamento' || department == 'clothing' || department == 'ropa') {
                clothingSizesFormatted.forEach(function(clothingSizeFormatted) {
                    if (clothingSizeFormatted.indexOf(firstVariant) > -1) {
                        sortArray = clothingSizeFormatted;
                    }
                });
            } else if (department == 'scarpe' || department == 'footwear' || department == 'zapatos') {
                shoeSizesFormatted.forEach(function(shoeSizeFormatted) {
                    if (shoeSizeFormatted.indexOf(firstVariant) > -1) {
                        sortArray = shoeSizeFormatted;
                    }
                });
            } else if (department == 'accessori' || department == 'accessories' || department == 'accesorios') {
                accessorySizesFormatted.forEach(function(accessorySizeFormatted) {
                    if (accessorySizeFormatted.indexOf(firstVariant) > -1) {
                        sortArray = accessorySizeFormatted;
                    }
                });
            }

            if (sortArray) {
                // Ordino le varianti a seconda della scala taglia selezionata
                Array.from(product.querySelectorAll(item)).sort(function(a, b) {
                    let sizeA = a.getAttribute('data-size') + '';
                    let sizeB = b.getAttribute('data-size') + '';

                    return sortArray.indexOf(sizeA) - sortArray.indexOf(sizeB);
                }).appendTo(product.querySelector(wrapper));
            }
        }
    });

};


function findInObjectValuesArray(object, value) {
    let found = false;

    Object.keys(object).forEach(function(objectKey) {
        for (let i = 0; i < object[objectKey].length; i++) {
            if (object[objectKey][i] == value) {
                found = object[objectKey][i];
                break;
            }
        }
    });

    return found;
}

function sortObjKeysAlphabetically(object) {
    if (!object) {
        return object;
    }

    const isArray = object instanceof Array;
    let sortedObj = {};

    if (isArray) {
        sortedObj = object.sort();
    } else {
        let keys = Object.keys(object);

        keys.sort(function(key1, key2) {
            if (key1.toLowerCase() < key2.toLowerCase()) return -1;
            if (key1.toLowerCase() > key2.toLowerCase()) return 1;

            return 0;
        });

        for (let index in keys) {
            let key = keys[index];

            if (object[key]) {
                sortedObj[key] = this.sortObjKeysAlphabetically(object[key]);
            }
        }
    }
    return sortedObj;
}

function handleize(str) {
    str = str.toLowerCase();

    var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];

    // For the old browsers
    for (var i = 0; i < toReplace.length; ++i) {
        str = str.replace(toReplace[i], "");
    }

    str = str.replace('/', "--");
    str = str.replace(/\W/g, "-");

    if (str.charAt(str.length - 1) == "-") {
        str = str.replace(/-+\z/, "");
    }

    if (str.charAt(0) == "-") {
        str = str.replace(/\A-+/, "");
    }

    return str
}

function hideLoadMore() {
    let loadMoreElement = document.querySelector('.load-more');
    if (loadMoreElement)
        loadMoreElement.style.display = 'none';
}

function showLoadMore() {
    let loadMoreElement = document.querySelector('.load-more');
    if (loadMoreElement)
        loadMoreElement.style.display = 'flex';
}

function hideLoader() {
    let loading = document.querySelector('[data-handle="generic-loading"]');
    if (loading)
        loading.style.display = 'none';
}

function showLoader() {
    let loading = document.querySelector('[data-handle="generic-loading"]');
    if (loading)
        loading.style.display = 'flex';
}

function jsUcfirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}


function getTopOffset(controlEl, offset) {
    return controlEl.getBoundingClientRect().top + window.scrollY - offset;
}

// Retrieves input data from a form and returns it as a JSON object:
function formToJSON(elements) {
    return [].reduce.call(elements, function(data, element) {
        data[element.name] = element.value;
        return data;
    }, {});
}

function getUrlString(data) {
    var urlParameters = Object.entries(data).map(function(e) {
        return e.join('=');
    }).join('&');

    return urlParameters;
}